export default "__VITE_ASSET__BkuhkXCB__"